export const Emojis = `
😀 😁 😂 🤣 😃 😄 😅 😊 🙂 😉
😍 😘 😗 😙 😚 😜 🤪 😝 😛 🤩
🤗 🤔 🤨 😐 😑 😶 🙄 😏 😒 😬
🤥 😌 😴 🤤 😪 😷 🤒 🤕 🤧 🥵
🥶 😎 🤓 🧐 😕 😟 🙁 ☹️ 😮 😲
😳 🥲 😭 😤 😡 🤯 👍 👎 👏 🙌
🙏 🔥 🎉 ✨ 💯 ❤️ 💔 💙 💚 💛
`
  .trim()
  .split(/\s+/);
